export default __webpack_public_path__ + "static/media/popup_bsm.8c3e311f.png";